/* eslint-disable sort-keys */
import { Spacing } from './styles.interface';

const defaultSpacing = 4;

export const spacing: Spacing = {
  base: {
    xxs: `${defaultSpacing}px`, //        4px
    xs: `${2 * defaultSpacing}px`, //     8px
    sm: `${3 * defaultSpacing}px`, //     12px
    md: `${4 * defaultSpacing}px`, //     16px
    lg: `${5 * defaultSpacing}px`, //     20px
    xl: `${6 * defaultSpacing}px`, //     24px
    xxl: `${7 * defaultSpacing}px`, //    28px
    xxxl: `${8 * defaultSpacing}px`, //   32px
    xxxxl: `${9 * defaultSpacing}px`, //  36px
  },
  mobile: {
    xxs: `${0.5 * defaultSpacing}px`, //   2px
    xs: `${defaultSpacing}px`, //          4px
    sm: `${1.5 * defaultSpacing}px`, //    6px
    md: `${2 * defaultSpacing}px`, //      8px
    lg: `${2.5 * defaultSpacing}px`, //    10px
    xl: `${3 * defaultSpacing}px`, //      12px
    xxl: `${3.5 * defaultSpacing}px`, //   14px
    xxxl: `${4 * defaultSpacing}px`, //    16px
    xxxxl: `${4.5 * defaultSpacing}px`, // 18px
  },
};
